let teamId = 1;

export let allTeams = [
  // {
  //   teamId: 1
  //   conference: 'AFC',
  //   division: 'North',
  //   name: 'Atlanta Falcons',
  // },

  { teamId: teamId++, conference: 'AFC', division: 'East', name: 'Buffalo Bills' },
  { teamId: teamId++, conference: 'AFC', division: 'East', name: 'Miami Dolphins' },
  { teamId: teamId++, conference: 'AFC', division: 'East', name: 'New England Patriots' },
  { teamId: teamId++, conference: 'AFC', division: 'East', name: 'New York Jets' },

  { teamId: teamId++, conference: 'AFC', division: 'North', name: 'Baltimore Ravens' },
  { teamId: teamId++, conference: 'AFC', division: 'North', name: 'Cincinnati Bengals' },
  { teamId: teamId++, conference: 'AFC', division: 'North', name: 'Cleveland Browns' },
  { teamId: teamId++, conference: 'AFC', division: 'North', name: 'Pittsburgh Steelers' },

  { teamId: teamId++, conference: 'AFC', division: 'South', name: 'Houston Texans' },
  { teamId: teamId++, conference: 'AFC', division: 'South', name: 'Indianapolis Colts' },
  { teamId: teamId++, conference: 'AFC', division: 'South', name: 'Jacksonville Jaguars' },
  { teamId: teamId++, conference: 'AFC', division: 'South', name: 'Tennessee Titans' },

  { teamId: teamId++, conference: 'AFC', division: 'West', name: 'Denver Broncos' },
  { teamId: teamId++, conference: 'AFC', division: 'West', name: 'Kansas City Chiefs' },
  { teamId: teamId++, conference: 'AFC', division: 'West', name: 'Las Vegas Raiders' },
  { teamId: teamId++, conference: 'AFC', division: 'West', name: 'Los Angeles Chargers' },
  
  { teamId: teamId++, conference: 'NFC', division: 'East', name: 'Dallas Cowboys' },
  { teamId: teamId++, conference: 'NFC', division: 'East', name: 'New York Giants' },
  { teamId: teamId++, conference: 'NFC', division: 'East', name: 'Philadelphia Eagles' },
  { teamId: teamId++, conference: 'NFC', division: 'East', name: 'Washington Commanders' },

  { teamId: teamId++, conference: 'NFC', division: 'North', name: 'Chicago Bears' },
  { teamId: teamId++, conference: 'NFC', division: 'North', name: 'Detroit Lions' },
  { teamId: teamId++, conference: 'NFC', division: 'North', name: 'Green Bay Packers' },
  { teamId: teamId++, conference: 'NFC', division: 'North', name: 'Minnesota Vikings' },

  { teamId: teamId++, conference: 'NFC', division: 'South', name: 'Atlanta Falcons' },
  { teamId: teamId++, conference: 'NFC', division: 'South', name: 'Carolina Panthers' },
  { teamId: teamId++, conference: 'NFC', division: 'South', name: 'New Orleans Saints' },
  { teamId: teamId++, conference: 'NFC', division: 'South', name: 'Tampa Bay Buccaneers' },

  { teamId: teamId++, conference: 'NFC', division: 'West', name: 'Arizona Cardinals' },
  { teamId: teamId++, conference: 'NFC', division: 'West', name: 'Los Angeles Rams' },
  { teamId: teamId++, conference: 'NFC', division: 'West', name: 'San Francisco 49ers' },
  { teamId: teamId++, conference: 'NFC', division: 'West', name: 'Seattle Seahawks' },
];